import store from '@/store';
import addService from '@/utils/changeItems/addService';
import router from '@/router/index';
import { notification } from '@/utils/notification';
import _ from 'lodash';
/**
 * 插入變更項目至操作的下一步
 * @param {Array<string>|string} codeList ex: ['B5','B6'] or 'b5'
 * @param {Array<object>} originServiceList 未新增之前的變更項目陣列
 * @param {String} latestCode 當前變更項目的 transactionItemNo
 */
const insertService = (codeList, originServiceList, latestCode) => {
    try {
        if (typeof codeList === 'string') {
            codeList = [codeList];
        }
        codeList.forEach((i) => {
            const index = originServiceList.findIndex(k => i === k.transactionItemNo);
            if (index > -1) {
                originServiceList.splice(index, 1);
            }
        });
        // 加入＆排序
        const atIndex = originServiceList.findIndex(i => i.transactionItemNo === latestCode);
        codeList.forEach((i, idx) => {
            const obj = store.state.services.transactionItems.find(k => i === k.transactionItemNo);
            obj && originServiceList.splice(atIndex + 1 + idx, 0, obj);
        });

        store.dispatch('services/setServices', originServiceList);
        router.push({ name: originServiceList[atIndex + 1].routeName });
        return '';
    } catch (e) {
        return e;
    }
};

/**
 * 新增變更項目 & 插入新增變更項目至操作的下一步
 * @param {Array<string>} codeList ex: ['B5','B6']
 * @param {String} latestCode 當前變更項目的 transactionItemNo
 */
const addAndInsertService = async (codeList, latestCode) => {
    const originServiceList = _.cloneDeep(store.state.services.serviceList);
    // let status = null;
    // 先加入成功再進行後續
    const { isNext } = await addService(codeList);
    if (isNext) {
        const e = await insertService(codeList, originServiceList, latestCode);
        return { isSuccess: e === '' };
    } else {
        notification({
            title: '系統提醒',
            text: '變更項目暫時無法進行'
        });
        return { isSuccess: false };
    }
};

export { insertService, addAndInsertService };
